module.exports = __webpack_public_path__ + "static/media/list-icon.3449f5d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-icon.svg
// module id = 1380
// module chunks = 1